if (!customElements.get('home-banner-autoplay')) {
  customElements.define('home-banner-autoplay', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.home-panels__track');
      const controls = this.querySelector('.home-panels__controls');
      const total = track.children.length;
      controls.hidden = total < 2;
      if (total < 2) return;
      const listeners = new AbortController();
      this.listeners = listeners;
      const on = (el, type, cb) => el.addEventListener(type, cb, { signal: listeners.signal });
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let playing = !reduced.matches;
      let visible = false;
      let touching = false;
      let timer;
      const index = () => Math.round(track.scrollLeft / track.clientWidth);
      const go = (i, wrap = false) => track.scrollTo({
        left: i * track.clientWidth,
        behavior: reduced.matches || wrap ? 'instant' : 'smooth'
      });
      const schedule = () => {
        clearTimeout(timer);
        if (!playing || !visible || document.hidden || touching ||
            (matchMedia('(hover: hover)').matches && this.matches(':hover')) ||
            this.matches(':focus-within')) return;
        timer = setTimeout(() => {
          const next = (index() + 1) % total;
          go(next, next === 0);
          schedule();
        }, 6000);
      };
      const rotation = document.createElement('button');
      rotation.type = 'button';
      rotation.className = 'home-panels__rotation';
      const render = () => {
        rotation.textContent = playing ? 'Ⅱ' : '▶';
        rotation.setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
      };
      on(rotation, 'click', () => { playing = !playing; render(); schedule(); });
      this.append(rotation);
      this.cleanup = () => { clearTimeout(timer); rotation.remove(); controls.replaceChildren(); };
      for (let i = 0; i < total; i++) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', this.getAttribute('aria-label') + ' — ' + (i + 1));
        button.setAttribute('aria-controls', track.id);
        on(button, 'click', () => { go(i); schedule(); });
        controls.append(button);
      }
      const update = () => {
        [...controls.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === index())));
        schedule();
      };
      on(track, 'scroll', update);
      on(this, 'touchstart', () => { touching = true; schedule(); });
      for (const event of ['touchend', 'touchcancel']) on(this, event, () => { touching = false; schedule(); });
      for (const event of ['mouseenter', 'mouseleave', 'focusin']) on(this, event, schedule);
      on(this, 'focusout', () => queueMicrotask(() => { if (!listeners.signal.aborted) schedule(); }));
      on(document, 'visibilitychange', schedule);
      on(reduced, 'change', () => { if (reduced.matches) { playing = false; render(); schedule(); } });
      this.observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        schedule();
      }, { threshold: 0.3 });
      this.observer.observe(this);
      render();
      update();
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.observer?.disconnect();
      this.cleanup?.();
    }
  });
}
